export const LocationEnum = {
    60001876 : "Ihakana VIII - Moon 6 - Nugoeihuvi Corporation Development Studio",
    60003760 : "Jita IV - Moon 4 - Caldari Navy Assembly Plant",
    60008494 : "Amarr VIII (Oris) - Emperor Family Academy",
    60012667 : "Osmon II - Moon 1 - Sisters of EVE Bureau",
    60003334 : "New Caldari Prime - Moon 1 - Chief Executive Panel Bureau",
    60003061 : "Mitsolen I - Moon 1 - Expert Housing Warehouse",
    60006430 : "Outuni IX - Moon 3 - Imperial Armaments Factory",
    60000301 : "Hentogaira III - Moon 6 - Prompt Delivery Storage",
    60004459 : "Osmon IV - Moon 5 - Science and Trade Institute School",
    60001486 : "Itamo VIII - Rapid Assembly Factory",
    60003172 : "Akkio V - Moon 6 - Caldari Funds Unlimited Vault",
    60002818 : "Poinen IV - Moon 8 - Sukuuvestaa Corporation Factory",
    1042508032148 : "Personal Structure",
    60001633 : "Uoyonen IX - Perkone Warehouse",
    60015027 : "Uitra VI - Moon 4 - State War Academy",
    60006880 : "Perimeter II - Moon 1 - Ducia Foundry Mineral Reserve",
    60000523 : "Nuken VII - Moon 20 - Hyasyoda Corporation Mining Outpost",
    60003046 : "Maila VII - Expert Housing Warehouse",
    60000964 : "Obe VI - Caldari Provisions Plantation",
    60000967 : "Osaa IV - Moon 11 - Caldari Provisions Plantation",
    60010192 : "Reisen VI - CreoDron Factory",
    60001630 : "Tasti VI - Moon 2 - Perkone Factory",
    60002815 : "Olo III - Moon 1 - Sukuuvestaa Corporation Warehouse",
    60001804 : "Maila VI - Moon 1 - Zainou Biotech Production",
    60000916 : "Maila VI - Moon 2 - Caldari Provisions Plantation",
    60002284 : "Sakkikainen VI - Moon 1 - Lai Dai Corporation Factory",
    60003004 : "Eskunen XI - Moon 1 - Caldari Constructions Production Plant",
    60000292 : "Geras IX - Moon 7 - Prompt Delivery Storage",
    60003067 : "Itamo VII - Moon 5 - Expert Housing Warehouse",
    60013144 : "Vouskiaho III - Genolution Biotech Production",
    60010198 : "Akora IX - Moon 19 - CreoDron Factory",
    60002236 : "Hentogaira I - Moon 10 - Ishukone Corporation Warehouse",
    60001627 : "Tasti VI - Moon 16 - Perkone Factory",
    60015157 : "Kisogo VII - AIR Laboratories",
    1029036975486 : "Personal Structure",
    60004051 : "Hurtoken VII - Moon 3 - Peace and Order Unit Testing Facilities",
    60000304 : "Hentogaira IV - Prompt Delivery Storage",
    60002233 : "Vasala V - Moon 15 - Ishukone Corporation Factory",
    60003079 : "Nomaa I - Expert Housing Production Plant",
    1029209158478 : "Personal Structure",
    60004228 : "Unpas IX - Moon 5 - Spacelane Patrol Logistic Support",
    60015002 : "Aokannitoh VII - Moon 2 - School of Applied Knowledge",
    60003109 : "Hykkota IV - Moon 7 - Expert Housing Production Plant",
    60004048 : "Saisio VII - Moon 1 - Peace and Order Unit Testing Facilities",
    1035269234104 : "Personal Structure",

}